import React from 'react';
import './LoginPage.scss';
import LoginForm from '../../components/LoginForm/LoginForm';
import { IonApp, IonContent } from '@ionic/react';
import Copyright from '../../components/Copyright/Copyright';
import logo_img from '../../assets/images/brand/login_logo.png';
const Login: React.FC = () => {
  return (
    <>
      <IonApp>
        <IonContent className="background">
          <div className="mob_logo_ctn mob-view">
            <img src={logo_img} className="mob_logo" />
            <div className="title-mob">User Sign-In</div>
          </div>
          <div className="login-card">
            <div className="left-side">
              <div className="title-row">
                <img src={logo_img} className="logo" />
              </div>
              <div className="title">User Sign-In</div>
            </div>
            <div className="right-side">
              <LoginForm />
            </div>
          </div>
          <div className="copy-right">
            <Copyright></Copyright>
          </div>
        </IonContent>
      </IonApp>
    </>
  );
};

export default Login;
